import { create } from 'zustand'

type MainNavStore = {
    openMainNav: boolean
    setOpenMainNav: (value: boolean) => void
}

export const useMainNavStore = create<MainNavStore>((set) => ({
    openMainNav: true,
    setOpenMainNav: (value) => set({ openMainNav: value }),
}))
